/* Cart Upsell - Les Delices de l Afrique */
(function(){
  if(window.location.pathname!=="/cart")return;

  /* --- CSS --- */
  var s=document.createElement("style");
  s.textContent=".cart-upsell{margin:28px 0 20px;padding:0;border-top:1.5px solid #e8e0d4}.cart-upsell__hdr{display:flex;align-items:center;gap:8px;padding:18px 0 14px}.cart-upsell__ttl{font-size:18px;font-weight:700;color:#1a1a1a;letter-spacing:-.3px}.cart-upsell__bdg{background:linear-gradient(135deg,#1B6B3A,#228B22);color:#fff;font-size:11px;font-weight:600;padding:3px 10px;border-radius:20px}.cart-upsell__row{display:flex;gap:12px;overflow-x:auto;padding:4px 2px 18px;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;scrollbar-width:none}.cart-upsell__row::-webkit-scrollbar{display:none}.cart-upsell__cd{flex:0 0 148px;scroll-snap-align:start;background:#fff;border:1.5px solid #e8e0d4;border-radius:12px;overflow:hidden;transition:border-color .2s,box-shadow .2s}.cart-upsell__cd:hover{border-color:#1B6B3A;box-shadow:0 2px 12px rgba(27,107,58,.12)}.cart-upsell__im{width:100%;height:130px;object-fit:cover;display:block;background:#f5f1ea}.cart-upsell__nf{padding:10px}.cart-upsell__nm{font-size:12.5px;font-weight:600;color:#1a1a1a;line-height:1.3;margin:0 0 4px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;min-height:33px}.cart-upsell__pr{font-size:14px;font-weight:700;color:#1B6B3A;margin:0 0 8px}.cart-upsell__ab{width:100%;padding:8px 0;border:none;border-radius:8px;background:#D4A017;color:#fff;font-size:12px;font-weight:700;cursor:pointer;transition:background .2s,transform .1s;letter-spacing:.3px}.cart-upsell__ab:hover{background:#b8890f}.cart-upsell__ab:active{transform:scale(.97)}.cart-upsell__ab.ok{background:#1B6B3A;pointer-events:none}";
  document.head.appendChild(s);

  /* --- LOGIC --- */
  async function init(){
    var cr=await fetch("/cart.json");
    var cd=await cr.json();
    if(!cd.items||cd.items.length===0)return;
    var pids=cd.items.map(function(i){return i.product_id});

    var recs=[];
    for(var i=0;i<pids.length&&recs.length<8;i++){
      try{
        var r=await fetch("/recommendations/products.json?product_id="+pids[i]+"&limit=8&intent=related");
        var d=await r.json();
        if(d.products)d.products.forEach(function(p){
          if(pids.indexOf(p.id)===-1&&!recs.find(function(x){return x.id===p.id})&&p.available)recs.push(p);
        });
      }catch(e){}
    }
    if(recs.length===0)return;

    var cards="";
    recs.slice(0,6).forEach(function(p){
      var img=(p.featured_image||(p.images&&p.images[0])||"");
      if(img.indexOf("//")===0)img="https:"+img;
      var pr=(p.price/100).toFixed(2).replace(".",",");
      var vid=p.variants&&p.variants[0]?p.variants[0].id:"";
      cards+='<div class="cart-upsell__cd">'+
        '<a href="/products/'+p.handle+'"><img class="cart-upsell__im" src="'+img+'" alt="'+p.title.replace(/"/g,"&quot;")+'" loading="lazy"></a>'+
        '<div class="cart-upsell__nf">'+
        '<p class="cart-upsell__nm">'+p.title+'</p>'+
        '<p class="cart-upsell__pr">'+pr+' \u20ac</p>'+
        '<button class="cart-upsell__ab" data-vid="'+vid+'">+ Ajouter</button>'+
        '</div></div>';
    });

    var wrap=document.createElement("div");
    wrap.className="cart-upsell-wrap";
    wrap.innerHTML='<div class="cart-upsell">'+
      '<div class="cart-upsell__hdr">'+
      '<span class="cart-upsell__ttl">Compl\u00e9tez votre commande</span>'+
      '<span class="cart-upsell__bdg">\ud83d\udd25 Populaire</span>'+
      '</div>'+
      '<div class="cart-upsell__row">'+cards+'</div>'+
      '</div>';

    var tgt=document.querySelector(".cart__note")||document.querySelector(".totals");
    if(tgt)tgt.parentNode.insertBefore(wrap,tgt);

    wrap.querySelectorAll(".cart-upsell__ab").forEach(function(btn){
      btn.addEventListener("click",function(){
        var vid=this.getAttribute("data-vid");
        var b=this;
        b.textContent="...";
        fetch("/cart/add.js",{
          method:"POST",
          headers:{"Content-Type":"application/json","X-Upsell":"1"},
          body:JSON.stringify({items:[{id:parseInt(vid),quantity:1}]})
        }).then(function(r){return r.json();})
        .then(function(){
          b.textContent="\u2713 Ajout\u00e9";
          b.classList.add("ok");
          setTimeout(function(){location.reload();},900);
        }).catch(function(){
          b.textContent="Erreur";
          setTimeout(function(){b.textContent="+ Ajouter";},2000);
        });
      });
    });
  }

  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",function(){setTimeout(init,300);});
  else setTimeout(init,300);
})();
